import type { ReactNode } from 'react';

interface Props {
  title: string;
  onBack?: () => void;
  children: ReactNode;
}

export default function ContentWrapper({ title, onBack, children }: Props) {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {onBack && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '11px 16px', background: 'var(--vs0)',
          borderBottom: '1px solid var(--shell-border)', flexShrink: 0,
        }}>
          <button
            onClick={onBack}
            style={{
              background: 'transparent', border: 'none', cursor: 'pointer',
              color: 'var(--shell-muted)', padding: '4px 2px',
              display: 'flex', alignItems: 'center', gap: 6,
              fontSize: '0.83rem', fontWeight: 600,
            }}
          >
            <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>←</span>
            Back
          </button>
          <span style={{ fontSize: '0.92rem', fontWeight: 700, color: 'var(--shell-text)', marginLeft: 4 }}>
            {title}
          </span>
        </div>
      )}
      {children}
    </div>
  );
}
